import { render, staticRenderFns } from "./app-detail-bind-modal.vue?vue&type=template&id=55390d50&scoped=true";
import script from "./app-detail-bind-modal.vue?vue&type=script&lang=js";
export * from "./app-detail-bind-modal.vue?vue&type=script&lang=js";
import style0 from "./app-detail-bind-modal.vue?vue&type=style&index=0&id=55390d50&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "55390d50", null);
export default component.exports;